const NotFoundIcon = () => {
  return (
    <svg
      width="300"
      height="170"
      viewBox="0 0 300 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M134.916 18.6445C191.359 23.4734 291.394 28.154 298.461 58.3698C304.558 84.4381 291.973 103.425 270.596 121.782C235.486 151.932 194.457 128.296 146.556 121.782C113.21 117.247 80.7302 128.129 62.9609 102.238C38.8398 67.0908 89.3445 14.7456 134.916 18.6445Z"
        fill="url(#paint0_linear_231_3)"
      />
      <path
        d="M101.348 74.2159C100.091 76.8466 98.3648 79.2637 97.0909 81.8981C96.0898 83.9683 94.8864 86.4671 95.1163 88.8271C95.1751 89.4309 95.3271 90.0842 95.5907 90.6347C97.0074 93.5927 100.652 93.7035 103.276 92.4219C106.941 90.6319 110.091 87.7738 113.144 85.1484C117.218 81.645 121.334 78.1156 125.172 74.3666C124.361 77.2608 122.805 79.8838 122.644 82.9525C122.466 86.3447 125.513 88.8541 128.873 87.7203C132.552 86.478 135.244 82.7538 137.893 80.1659C138.689 82.8632 141.982 83.8138 144.524 83.329C149.623 82.3566 153.985 78.8047 158.17 76.0235C157.799 77.7771 157.29 79.4886 157.587 81.2956C157.695 81.9521 157.913 82.5905 158.23 83.1785C160.18 86.7973 164.178 86.4426 167.576 85.3626C167.987 88.472 171.167 89.7711 174.053 89.2185C179.291 88.215 184.158 84.7288 188.624 82.0487C188.145 84.0692 187.658 86.2242 189.189 87.9984C189.692 88.5809 190.481 88.7633 190.984 89.2951C191.472 89.8106 191.708 90.5023 192.249 91.0045C193.909 92.5454 196.013 92.873 198.184 92.457C204.217 91.3014 209.071 86.5537 213.836 83.1032C214.489 85.7865 217.745 86.4402 220.081 85.7602C222.652 85.0116 224.994 83.4538 227.251 82.0807C229.665 80.612 232.237 79.2154 234.498 77.5298C233.17 81.586 231.382 85.588 230.662 89.8062C230.329 91.7596 230.362 94.1615 231.88 95.6797C233.77 97.5699 236.709 97.2546 238.816 95.93C243.124 93.2204 246.85 89.2632 250.458 85.7392C250.068 87.3176 250.156 89.379 251.033 90.7853C252.43 93.0248 255.411 93.3141 257.628 92.1969C261.412 90.2898 264.158 86.6659 267.111 83.781C269.526 81.422 272.442 79.4049 274.479 76.7002C276.054 74.6103 274.501 71.6576 271.814 71.6574C269.431 71.6572 267.437 73.4134 265.723 74.8124C263.87 76.3245 262.184 77.9746 260.48 79.6386C261.193 77.5816 262.409 75.3992 262.164 73.1615C261.839 70.2119 258.45 68.8119 255.932 70.2151C253.682 71.469 251.81 73.7986 249.995 75.5716C246.69 78.8006 243.309 81.9447 239.972 85.1367C240.941 82.2272 242.035 79.3884 242.738 76.4001C243.142 74.6864 243.465 72.6042 242.848 70.9021C242.626 70.2893 242.264 69.6493 241.809 69.1727C238.013 65.1947 232.661 69.8414 229.255 71.9245C228.251 72.5387 227.19 73.1375 226.249 73.8394C226.947 72.6147 227.942 71.6888 228.086 70.2242C228.36 67.4392 225.611 65.1068 222.856 66.0592C221.8 66.4242 220.924 67.2423 220.081 67.9338C218.283 69.4082 216.603 71.1682 214.684 72.4837C217.109 69.3392 220.916 65.3287 220.289 61.0357C219.812 57.7663 216.838 56.3671 213.758 57.0185C210.591 57.6886 208.02 60.2259 205.743 62.303C204.84 63.1273 203.491 64.15 202.965 65.2534C199.936 64.6961 197.723 67.0794 195.409 68.6406C192.007 70.9352 188.58 73.2037 185.078 75.3494C183.385 76.3867 181.674 77.6596 179.835 78.4336C180.627 77.4744 181.455 76.4693 181.595 75.195C181.871 72.6852 179.724 70.4005 177.059 70.9524C175.456 71.2845 174.231 72.6099 172.973 73.5468C170.711 75.2321 168.211 76.9834 165.572 78.057C166.363 76.0387 167.138 74.0276 167.994 72.0318C168.734 70.3099 169.61 68.5254 169.413 66.6091C169.094 63.4959 165.883 62.3271 163.182 63.4045C161.268 64.1677 159.577 65.644 157.939 66.8446C155.382 68.7174 152.811 70.5762 150.152 72.308C148.8 73.1884 147.409 74.1879 145.911 74.8185C146.733 72.4453 148.495 70.013 148.375 67.4375C148.255 64.8431 145.1 63.1048 142.75 64.1472C141.384 64.7533 140.391 66.0622 139.423 67.1363C137.657 69.0964 135.926 71.0903 134.115 73.0109C135.102 69.4857 137.594 66.3327 137.957 62.6174C138.209 60.04 136.091 57.7751 133.421 58.036C132.121 58.163 130.926 58.9408 129.952 59.7368C127.983 61.3456 126.2 63.1626 124.324 64.8701C120.422 68.4205 116.56 72.0146 112.605 75.5091C110.526 77.3455 108.515 79.3338 106.283 80.9943C107.153 79.1735 108.339 77.4446 109.397 75.7222C111.147 72.873 112.897 70.0227 114.711 67.2116C116.638 64.2248 118.592 61.2622 120.597 58.3244C121.572 56.8962 122.85 55.5082 123.605 53.9561C124.607 51.8963 124.139 49.348 121.779 48.4168C119.777 47.6269 118.144 48.6841 116.691 49.9518C114.724 51.6676 112.863 53.4957 110.908 55.2236C104.423 60.9558 98.202 66.9694 91.7108 72.6968C89.5506 74.6029 87.3985 76.5183 85.2345 78.4209C83.8152 79.6687 82.1065 80.8907 80.9974 82.4253C78.776 85.4992 82.4285 89.5737 85.8513 87.903C86.7777 87.4508 87.4349 86.6613 88.1643 85.9663C88.981 85.188 89.8605 84.4641 90.7085 83.7184C94.2719 80.5855 97.9581 77.5276 101.348 74.2159Z"
        fill="url(#paint1_linear_231_3)"
      />
      <path
        d="M101.271 74.2167L101.194 74.518H101.271V74.2167Z"
        fill="url(#paint2_linear_231_3)"
      />
      <path
        d="M95.1033 87.7733V88.0746H95.1804L95.1033 87.7733Z"
        fill="url(#paint3_linear_231_3)"
      />
      <path
        d="M38.7399 140.246C39.9899 142.995 38.7217 146.214 35.9073 147.435C33.0929 148.656 29.798 147.417 28.548 144.668C27.298 141.919 28.5662 138.7 31.3806 137.479C34.195 136.258 37.4899 137.497 38.7399 140.246Z"
        fill="url(#paint4_linear_231_3)"
      />
      <path
        d="M78.3839 89.5457C79.6339 92.295 78.3657 95.5137 75.5513 96.7348C72.7369 97.9559 69.442 96.717 68.1919 93.9677C66.9419 91.2183 68.2101 87.9997 71.0246 86.7786C73.839 85.5575 77.1339 86.7963 78.3839 89.5457Z"
        fill="url(#paint5_linear_231_3)"
      />
      <path
        d="M29.1343 140.442C28.7968 140.19 28.7323 139.719 28.9902 139.389L68.837 88.4555C69.0949 88.1258 69.5776 88.0628 69.9151 88.3148L77.5537 94.0173C77.8912 94.2693 77.9557 94.7408 77.6978 95.0705L37.851 146.004C37.593 146.334 37.1104 146.397 36.7729 146.145L29.1343 140.442Z"
        fill="url(#paint6_linear_231_3)"
      />
      <path
        d="M124.527 85.2557C112.245 100.893 89.3125 103.844 73.3048 91.8463C57.2971 79.8488 54.2765 57.4463 66.5581 41.809C78.8397 26.1716 101.773 23.2208 117.78 35.2183C133.788 47.2158 136.809 69.6183 124.527 85.2557ZM72.6043 46.3405C62.8847 58.7159 65.2752 76.4452 77.9436 85.94C90.6121 95.4347 108.761 93.0995 118.481 80.7242C128.2 68.3488 125.81 50.6195 113.142 41.1247C100.473 31.6299 82.324 33.9651 72.6043 46.3405Z"
        fill="url(#paint7_linear_231_3)"
      />
      <ellipse
        cx="28.747"
        cy="28.5734"
        rx="28.747"
        ry="28.5734"
        transform="matrix(0.800199 0.599735 -0.617669 0.786439 90.3228 23.8031)"
        fill="url(#paint8_linear_231_3)"
        fill-opacity="0.5"
      />
      <path
        d="M54.2564 15.0563C53.9899 14.3227 54.3825 13.5171 55.1334 13.2567L56.0171 12.9503C56.768 12.6899 57.5928 13.0735 57.8593 13.807L60.1033 19.9828C60.3698 20.7163 59.9771 21.522 59.2262 21.7824L58.3425 22.0888C57.5916 22.3491 56.7669 21.9656 56.5004 21.2321L54.2564 15.0563Z"
        fill="url(#paint9_linear_231_3)"
      />
      <path
        d="M56.2685 15.9099C57.6879 15.7693 56.8708 15.319 57.971 14.4317C59.0712 13.5445 59.8773 12.3584 60.2875 11.0236C60.6977 9.68874 60.6934 8.26506 60.2753 6.93258C59.8572 5.60009 59.044 4.41865 57.9385 3.53764C56.833 2.65664 55.485 2.11565 54.0648 1.98308C52.6445 1.85052 51.216 2.13233 49.9597 2.79288C48.7035 3.45343 47.6759 4.46305 47.0071 5.69407C46.3382 6.92509 46.058 8.32222 46.202 9.70879C46.346 11.0954 49.4227 10.1776 49.3417 9.39769C49.2607 8.61774 49.4183 7.83185 49.7946 7.13939C50.1708 6.44693 50.7488 5.87901 51.4555 5.50745C52.1621 5.13589 52.9657 4.97737 53.7646 5.05194C54.5634 5.12651 55.3218 5.43082 55.9436 5.92639C56.5654 6.42195 57.0229 7.08652 57.258 7.83606C57.4932 8.58559 57.4956 9.38641 57.2649 10.1373C57.0342 10.8881 56.5807 11.5553 55.9618 12.0544C55.343 12.5535 54.0632 13.3131 54.1171 14.3568C54.1725 15.4297 54.8491 16.0505 56.2685 15.9099Z"
        fill="url(#paint10_linear_231_3)"
      />
      <path
        d="M61.563 24.0004C61.9162 24.9723 61.3959 26.0399 60.401 26.3848C59.4061 26.7298 58.3133 26.2216 57.9601 25.2497C57.607 24.2778 58.1273 23.2102 59.1222 22.8653C60.1171 22.5203 61.2099 23.0285 61.563 24.0004Z"
        fill="url(#paint11_linear_231_3)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_231_3"
          x1="56.0214"
          y1="28.6514"
          x2="325.178"
          y2="137.848"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#BAC4FF" />
          <stop offset="1" stop-color="#E3E8FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_231_3"
          x1="79.7552"
          y1="52.3628"
          x2="234.821"
          y2="174.323"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#506AFF" />
          <stop offset="1" stop-color="#4A66FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_231_3"
          x1="89.4271"
          y1="74.1739"
          x2="89.4536"
          y2="76.6328"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#506AFF" />
          <stop offset="1" stop-color="#4A66FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_231_3"
          x1="95.103"
          y1="87.7994"
          x2="95.2021"
          y2="87.8044"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#506AFF" />
          <stop offset="1" stop-color="#4A66FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_231_3"
          x1="94.1655"
          y1="114.95"
          x2="16.1465"
          y2="99.1672"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0D28BA" />
          <stop offset="1" stop-color="#5169F2" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_231_3"
          x1="94.1655"
          y1="114.95"
          x2="16.1465"
          y2="99.1672"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0D28BA" />
          <stop offset="1" stop-color="#5169F2" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_231_3"
          x1="94.1655"
          y1="114.95"
          x2="16.1465"
          y2="99.1672"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0D28BA" />
          <stop offset="1" stop-color="#5169F2" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_231_3"
          x1="112.623"
          y1="107.037"
          x2="68.1872"
          y2="24.6741"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0D28BA" />
          <stop offset="1" stop-color="#5169F2" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_231_3"
          x1="-0.166229"
          y1="4.93299"
          x2="71.1061"
          y2="19.0808"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#B5CBFF" />
          <stop offset="1" stop-color="#E8EBFF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_231_3"
          x1="45.0607"
          y1="6.76101"
          x2="62.7653"
          y2="2.42651"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#506AFF" />
          <stop offset="1" stop-color="#4A66FF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_231_3"
          x1="45.0607"
          y1="6.76101"
          x2="62.7653"
          y2="2.42651"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#506AFF" />
          <stop offset="1" stop-color="#4A66FF" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_231_3"
          x1="45.0607"
          y1="6.76101"
          x2="62.7653"
          y2="2.42651"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#506AFF" />
          <stop offset="1" stop-color="#4A66FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NotFoundIcon;
